import styled from "styled-components/macro";

import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import SortBar from "../../components/sort_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Main from '../../components/main';
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import {useFeedback} from "../../store/feedback";
import {useQuery} from "../../utils/router";
import Wrapper from "../../components/wrapper";
import {useCommunityStyle} from "../../api/communities";
import {useBaseCommunity} from "../../store/hooks";
import {useSettings} from "../../store";
import {useSearch} from "../../api/feed";
import PostList from "../../components/post_list";
import HeaderData from "../../components/header_data";
import Pagination from "../../components/pagination";
import {isPseudoCommunity} from "../../store/communites";
import NavLink from "../../components/nav_link";
import LegacySortBar from "../../components/legacy/legacy_sort_bar";
import useWindowDimensions from "../../utils/dimensions";

const NoResults = styled.div``;

const Search = styled(({className}) => {

    const baseCommunity = useBaseCommunity();
    const style = useCommunityStyle(baseCommunity);

    const page = parseInt(useQuery().page || '1');
    const {expand} = useSettings();
    const {query, params, sort = 'new', community = 'Win'} = useQuery();
    const searchTerm = query ? query : params;
    const {busy, feedbackCh} = useFeedback();
    const {posts} = useSearch(feedbackCh, searchTerm, community, sort, page);

    const {width} = useWindowDimensions();

    return (
        <div className={className}>
            <HeaderData title='Search' community={baseCommunity} community_style={style}/>
            <Header>
                {(baseCommunity !== "TheDonald" || width <= 780) && <TopBar legacyConversion={baseCommunity === "TheDonald"} page={'Search Results'}/>}
                {!isPseudoCommunity(baseCommunity) &&
                    <>
                        <CommunityHeader community={baseCommunity}/>
                    </>
                }
                {baseCommunity === "TheDonald" && width > 780 && <LegacySortBar />}
            </Header>
            <SortBar community={baseCommunity} />
            <Container>
                <Wrapper>
                    <Main>
                        {busy || posts.length > 0 ? <PostList
                            initialExpand={expand}
                            posts={posts}
                            loading={busy}
                            show_community
                        />
                            :
                            <NoResults>
                                {isPseudoCommunity(community) ?
                                    'No results found.'
                                        :
                                    <>No results found in {community} - <NavLink href={`/search?query=${searchTerm}`} react_route>search all communities.</NavLink></>
                                }
                            </NoResults>}
                    </Main>
                    {posts.length > 0 &&
                        <Pagination path={`/search?query=${searchTerm}&community=${community}&sort=${sort}&page=`} has_more page={page} />
                    }
                </Wrapper>
                <Sidebar sidebar={style && style.sidebar} community={baseCommunity} />
            </Container>
            <Footer />
        </div>
    );
})`
${NoResults} {
  padding: 16px;
  font-size: 14px;
}
${NoResults} a {
  color: ${({theme}) => theme.placeholder_link_2};
}`;

export default Search;
